import type { ToolTrackingConfig } from '@analytics/models';
import { createToolStepConfig, parseToolConfig } from '@analytics/utils';
import type {
  MultipleAnswerQuestion,
  SingleAnswerQuestion,
} from '@feh/shared-ui';

import { homebatteryQuestionnaireStructure } from './homebattery-questionnaire-old.structure';
import { selectHomebatteryQuestionnaireAnalyticsPayload } from './homebattery-questionnaire.selectors';

export function generateHomebatteryFunnelSteps(
  questions: (SingleAnswerQuestion | MultipleAnswerQuestion)[]
) {
  const questionnaireSteps = () => {
    let step = 0;
    return questions.map((elem) => {
      step = step + 1;
      return {
        step,
        stepName: elem.trackingStepName,
        id: elem.trackingStepName,
      };
    });
  };

  return [
    {
      step: 0,
      stepName: '',
      id: 'homebattery-check',
    },
    ...questionnaireSteps(),
  ] as const;
}

const homebatteryFunnelSteps = generateHomebatteryFunnelSteps(
  Object.values(homebatteryQuestionnaireStructure)
);

export type HomebatteryFunnelToolTrackingSteps =
  (typeof homebatteryFunnelSteps)[number]['id'];

const heatpumpsFunnelToolTrackingConfig: ToolTrackingConfig<HomebatteryFunnelToolTrackingSteps> =
  {
    toolName: 'thuisbatterij check',
    steps: homebatteryFunnelSteps,
    toolComplete: createToolStepConfig(
      selectHomebatteryQuestionnaireAnalyticsPayload,
      (payload) => ({
        step: homebatteryFunnelSteps[homebatteryFunnelSteps.length - 1].step,
        payload,
      })
    ),
  };

export const parsedHomebatteryFunnelToolTrackingConfig = parseToolConfig(
  heatpumpsFunnelToolTrackingConfig
);
